// URL: https://observablehq.com/@jianan-li/human-suffering-1960-2016
// Title: Human Suffering 1960-2016
// Author: Jianan Li (@jianan-li)
// Version: 749
// Runtime version: 1
/* eslint-disable */
const m0 = {
  id: "4b5cd2654f690e9c@749",
  variables: [
    {
      inputs: ["md"],
      value: (function(md){return(
md`# Human Suffering 1960-2016`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `<a href="https://data.worldbank.org/indicator/SP.DYN.LE00.IN" target="_blank">Data →</a>`
)})
    },
    {
      name: "chart",
      inputs: ["d3","DOM","width","height","lifeExpectancyDeltaMax","color","sphere","geoGenerator","countries","life","onMouseOverArea","onMouseMoveArea","onMouseOutArea","interiorBorders","generateCountryLabelTransformValue","generateCountryLabelFontValue"],
      value: (function(d3,DOM,width,height,lifeExpectancyDeltaMax,color,sphere,geoGenerator,countries,life,onMouseOverArea,onMouseMoveArea,onMouseOutArea,interiorBorders,generateCountryLabelTransformValue,generateCountryLabelFontValue)
{
  console.log('Redraw chart!')
  
  const svg = d3.select(DOM.svg(width, height))
    .attr('id', 'svg-globe')
    .style('background-color', '#bbb')

  // Add gradient as a def element to be reference later
  const defs = svg.append("defs");
  
  const ticks = [-lifeExpectancyDeltaMax, 0, lifeExpectancyDeltaMax];
  
  const linearGradient = defs
    .append("linearGradient")
    .attr("id", "linear-gradient");

  linearGradient
    .selectAll("stop")
    .data(
      ticks.map((t, i, n) => ({
        offset: `${(100 * i) / (n.length-1)}%`,
        color: color(t)
      }))
    )
    .enter()
    .append("stop")
    .attr("offset", d => d.offset)
    .attr("stop-color", d => d.color);
  
  // Add the sphere layer
  svg
    .append("g")
    .attr("id", "sphere-container")
    .append("path")
    .datum(sphere)
    .attr("fill", "#E8F5FF")
    .attr("d", geoGenerator);
  
  // Add Chloropleth
  svg
    .append("g")
    .attr("id", "chloropleth-container")
    .selectAll("path")
    .data(countries, d => d.id)
    .enter()
    .append("path")
    .attr('id', d => `country-${d.id}`)
    .attr("fill", d =>
      life.has(d.id) && life.get(d.id)['1961delta']
        ? color(+life.get(d.id)['1961delta'])
        : "#eee"
    )
    .attr("d", geoGenerator)
    .on("mouseover", onMouseOverArea)
    .on("mousemove", onMouseMoveArea)
    .on("mouseout", onMouseOutArea);
  
  // Add country border
  svg
    .append("g")
    .attr("id", "border-container")
    .append("path")
    .datum(interiorBorders)
    .attr('id', "border")
    .attr("fill", "none")
    .attr("stroke", "white")
    .attr("stroke-linejoin", "round")
    .attr("d", geoGenerator);

  // Add country labels
  svg
    .append("g")
    .attr("id", "country-label-container")
    .selectAll("text")
    .data(countries, d => d.id)
    .enter()
    .append("text")
    .attr("class", "country-label")
    .attr("text-anchor", "middle")
    .attr("alignment-baseline", "middle")
    .text(d => d.properties.name)
    .attr("transform", generateCountryLabelTransformValue)
    .style('visibility', 'hidden')
    .style('font', generateCountryLabelFontValue)
    .style('opacity', 0)
    .style("pointer-events", "none")
  
  return svg.node();
}
)
    },
    {
      name: "viewof nextButton",
      inputs: ["html"],
      value: (function(html)
{
  const button = html`<button id="nextButton" name="input" type="button">Start</button>`;
  return button;
}
)
    },
    {
      name: "nextButton",
      inputs: ["Generators","viewof nextButton"],
      value: (G, _) => G.input(_)
    },
    {
      inputs: ["$"],
      value: (function($){return(
$("#nextButton").wrap('<div class="flex-container"></div>')
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Story Navigation ↓`
)})
    },
    {
      name: "journey",
      value: (function(){return(
[
  {
    country: "Vietnam",
    numericCode: "704",
    projectionScaleZoomOut: 400,
    projectionScaleZoomIn: 1100,
    startYear: 1968,
    endYear: 1970,
    title: "Vietnam War",
    description: "Fought between North Vietnam and South Vietnam from 1955 to 1975, the Vietnam War was a proxy war between the United States and the Soviet Union. An estimated 1.3 to 4.2 million people were killed, with more than half being Vietnamese civilians.",
    link: "https://en.wikipedia.org/wiki/Vietnam_War",
    imgSrc: "https://github.com/Jianan-Li/File-Hosting/raw/master/Vietnam%20War.jpg"
  },
  {
    country: "Cambodia",
    numericCode: "116",
    projectionScaleZoomOut: 1100,
    projectionScaleZoomIn: 1100,
    startYear: 1971,
    endYear: 1977,
    title: "Cambodian Genocide",
    description: "With the goal of turning the country into a socialist agrarian republic, the Khmer Rouge regime forced millions into labor camps where they were starved and abused. An estimated 1.7 to 1.9 million Cambodian (21—24% of the population) died during the 4-year period.",
    link: "https://en.wikipedia.org/wiki/Cambodian_genocide",
    imgSrc: "https://github.com/Jianan-Li/File-Hosting/raw/master/Cambodian%20Genocide.jpg"
  },
  {
    country: "Timor-Leste",
    numericCode: "626",
    projectionScaleZoomOut: 900,
    projectionScaleZoomIn: 1800,
    startYear: 1972,
    endYear: 1977,
    title: "East Timor Genocide",
    description: "During the US-backed invasion and occupation of East Timor from 1975 to 1999, the Indonesian military commited genocide against the East Timorese people. An estimated 100,000 to 300,000 East Timorese (14—42% of the population) were killed or died of starvation.",
    link: "https://en.wikipedia.org/wiki/East_Timor_genocide",
    imgSrc: "https://github.com/Jianan-Li/File-Hosting/raw/master/Indonesian%20Invasion%20of%20East%20Timor.jpg"
  },
  {
    country: "Iran",
    numericCode: "364",
    projectionScaleZoomOut: 500,
    projectionScaleZoomIn: 950,
    startYear: 1978,
    endYear: 1982,
    title: "Iran–Iraq War",
    description: "In an attempt to replace Iran as the dominant Persian Gulf state, Iraq invaded Iran in 1980, starting the 8-year long war between the two countries. It is estimated that over a million lives were lost during the war.",
    link: "https://en.wikipedia.org/wiki/Iran%E2%80%93Iraq_War",
    imgSrc: "https://github.com/Jianan-Li/File-Hosting/raw/master/Iran%E2%80%93Iraq%20War.jpg"
  },
  {
    country: "Rwanda",
    numericCode: "646",
    projectionScaleZoomOut: 500,
    projectionScaleZoomIn:2000,
    startYear: 1987,
    endYear: 1992,
    title: "Rwandan Genocide",
    description: "The Rwandan genocide was a mass slaughter of the Tutsis directed by members of the Hutu-majority government during the Rwandan Civil War from 1990 to 1994. An estimated 500,000 to 1,000,000 Rwandans were killed, constituting an estimated 70% of the Tutsi population.",
    link: "https://en.wikipedia.org/wiki/Rwandan_genocide",
    imgSrc: "https://github.com/Jianan-Li/File-Hosting/raw/master/Rwandan%20Genocide.jpg"
  },
  {
    country: "Zambia",
    numericCode: "894",
    projectionScaleZoomOut: 680,
    projectionScaleZoomIn: 680,
    startYear: 1985,
    endYear: 2002,
    title: "HIV/AIDS Pandemic in Sub-Saharan Africa",
    description: "The 1990s was a bleak time in the history of AIDS in Africa. In 1993 there were an estimated 9 million people infected in the sub-Saharan region out of a global total of 14 million. In the countries most affected, AIDS lowered life expectancy by about twenty years.",
    link: "https://en.wikipedia.org/wiki/HIV/AIDS_in_Africa",
    imgSrc: "https://github.com/Jianan-Li/File-Hosting/raw/master/AIDS.jpg"
  },
  {
    country: "Kazakhstan",
    numericCode: "398",
    projectionScaleZoomOut: 400,
    projectionScaleZoomIn: 500,
    startYear: 1988,
    endYear: 1993,
    title: "Dissolution of the Soviet Union",
    description: "Following the dissolution of the Soviet Union in 1991, Russia experienced one of the most extreme increases in mortality in modern history. Hidden behind the high rates of cardiovascular disease and injury caused by alcohol abuse is a sense of being unneeded by the state.",
    link: "https://en.wikipedia.org/wiki/Dissolution_of_the_Soviet_Union",
    imgSrc: "https://cdn.theatlantic.com/assets/media/img/photo/2011/12/20-years-since-the-fall-of-the-soviet-union/u01_77728401/main_1200.jpg"
  },
  {
    country: "Dem. Rep. Korea",
    numericCode: "408",
    projectionScaleZoomOut: 700,
    projectionScaleZoomIn: 1335,
    startYear: 1992,
    endYear: 1997,
    title: "North Korean Famine",
    description: "A combination of government mismanagement, loss of Soviet support, and a series of floods and droughts lead to the North Korean famine from 1994 to 1998. An estimated 240,000 to 3.5 million North Koreans died from starvation or hunger-related illnesses.",
    link: "https://en.wikipedia.org/wiki/North_Korean_famine",
    imgSrc: "https://github.com/Jianan-Li/File-Hosting/raw/master/North%20Korean%20Famine.jpg"
  },
  {
    country: "Syria",
    numericCode: "760",
    projectionScaleZoomOut: 500,
    projectionScaleZoomIn: 1630,
    startYear: 2007,
    endYear: 2013,
    title: "Syrian Civil War",
    description: "What started as a peaceful protest in 2011 demanding democratic reforms quickly escalated into full-blown warfare involving several nations, rebel groups and terrorist organizations. An estimated 370,000 to 570,000 people have been killed, and more than 5 millions became refugees.",
    link: "https://en.wikipedia.org/wiki/Syrian_Civil_War",
    imgSrc: "https://www.history.com/.image/c_limit%2Ccs_srgb%2Cq_auto:good%2Cw_1720/MTU4NTQyMDg3Mzc2MDg2Mzcy/syria-civil-war-getty-462518530.webp"
  },
]
)})
    },
    {
      name: "countryIndex",
      inputs: ["nextButton","journey"],
      value: (function*(nextButton,journey)
{
  nextButton;
  console.log('Calculating the next countryIndex.')
  if (typeof this === 'undefined') yield -1
  else if (this === journey.length-1) {
    yield 0
  }
  else {
    let countryIndex=this
    yield ++countryIndex
  }
}
)
    },
    {
      name: "i",
      inputs: ["countryIndex","projection","updateOnProjectionChange","Promises"],
      value: (function*(countryIndex,projection,updateOnProjectionChange,Promises)
{
  let i = this || 0;
  if (countryIndex !== -1) return yield i;
  while (true) {
    let [a,b,c] = projection.rotate()
    projection.rotate([a+1,b,c])
    updateOnProjectionChange()
    yield Promises.tick(100, i++);
  }
}
)
    },
    {
      name: "handleButtonClick",
      inputs: ["countryIndex","d3","showQuote","removeQuoteContainer","projection","width","moveToLeftTwoThirds","addJourneyInfoContainer","addLegend","addYear","visitCountry"],
      value: (async function(countryIndex,d3,showQuote,removeQuoteContainer,projection,width,moveToLeftTwoThirds,addJourneyInfoContainer,addLegend,addYear,visitCountry)
{
  if (countryIndex === -1) {
    if (d3.select('#quote-container').empty()) {
      showQuote()
    }
  }
  else {
    d3.select('#nextButton')
        .text("→");
    
    if (d3.select('#quote-container').node()) {
      removeQuoteContainer()
    }
    if (projection.translate()[0] === width/2) {
      await moveToLeftTwoThirds()    
    }
    if (d3.select('#journey-info-container').empty()) {
      addJourneyInfoContainer()
    }
    if (d3.select('#legend-container').empty()) {
      addLegend()
    }
    if (d3.select('.yearText').empty()) {
      addYear()
    }

    
    await visitCountry()
  }
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Add/Remove elements ↓`
)})
    },
    {
      name: "showQuote",
      inputs: ["d3","chart","width","height"],
      value: (function(d3,chart,width,height){return(
() => {
  
  let svg = d3.select(chart)
  
  let quoteContainer = svg
    .append('g')
    .attr('id', 'quote-container')
  
  quoteContainer
    .append('rect')
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', width)
    .attr('height', height)
    .attr('fill', '#aaa')
    .attr('fill-opacity', '0.5')
  
  quoteContainer
    .append('text')
    .attr('text-anchor', 'middle')
    .attr('x', width/2)
    .attr('y', height*0.4)
    .style('font', `bold ${width/24}px Palatino, serif`)
    .text('Human suffering anywhere concerns')
  
  quoteContainer
    .append('text')
    .attr('text-anchor', 'middle')
    .attr('x', width/2)
    .attr('y', height*0.4 + width/24*1.4)
    .style('font', `bold ${width/24}px Palatino, serif`)
    .text('men and women everywhere.')
  
  quoteContainer
    .append('text')
    .attr('text-anchor', 'middle')
    .attr('x', width/2)
    .attr('y', height*0.4 + width/24*1.4*2.8)
    .style('font', `${width/30}px Palatino, serif`)
    .text('Elie Wiesel')
}
)})
    },
    {
      name: "removeQuoteContainer",
      inputs: ["d3","chart"],
      value: (function(d3,chart){return(
() => {
  let svg = d3.select(chart)
  
  // Remove quote container
  svg
    .select('#quote-container')
    .transition('remove-quote-container')
    .duration(1000)
    .style('opacity', 0)
    .remove()
}
)})
    },
    {
      name: "addLegend",
      inputs: ["d3","chart","width","height","xScale","location","xAxis"],
      value: (function(d3,chart,width,height,xScale,location,xAxis){return(
() => {
  
  let svg = d3.select(chart)
  
  // Add legend scale
  // const legendContainer = svg
  //   .append("g")
  //   .attr('id', 'legend-container')
  //   .attr("transform", `translate(${width/2-50},${height - 30})`);
  
    // The right 1/3 showing relevant information
  let legendContainer = svg.append('foreignObject')
    .attr('x', width*(2/3))
    .attr('y', height*0.85+20)
    .attr('width', width*(1/3))
    .attr('height', height*0.15-20)
    .append("xhtml:div")
    .attr('id', 'legend-container')
    .style('background-color', '#fff')
    .style('box-shadow', '0 1px 4px 0 rgba(0, 0, 0, 0.37)')
    .style('border-radius', '5px 5px 0px 0px')
    .style('margin-left', `10px`)
    .style('width', `${width*(1/3)-20}px`)
    .style('height', `${height*0.15-20}px`)
    .style('overflow', 'hidden')
    .style('opacity', 0);
 
  let legendContainerSVG = legendContainer
    .append("svg")
    .style('width', `${width/3-20}px`)
    .style('height', `${height*0.2-20}px`)
  
  // The color gradient scale
  legendContainerSVG.append("rect")
    .attr('transform', `translate(${(width/3-20)/2},${(height*0.15-20)/2})`)
    .attr("height", `${width/120}px`)
    .attr("x", xScale(-2))
    .attr("y", `${width/240}px`)
    .attr("width", xScale(2) - xScale(-2))
    .style("fill", `url(${location}#linear-gradient)`);

  // Title
  legendContainerSVG.append("text")
    .attr('transform', `translate(${(width/3-20)/2},${(height*0.15-20)/2})`)
    .attr("class", "caption")
    .attr("x", 0)
    .attr("y", -6)
    .attr("fill", "#000")
    .attr("text-anchor", "middle")
    .attr("font-weight", "bold")
    .attr("font-size", `${width/90}px`)
    .text(`Change in life expectancy from the previous year`);
  
  // Legend scale axis
  legendContainerSVG
    .call(xAxis)
    .select(".domain")
    .remove();
  
  legendContainerSVG
    .selectAll('.tick')
    .selectAll('*')
    .attr('transform', `translate(${(width/3-20)/2},${(height*0.15-20)/2})`)
  
  legendContainerSVG
    .selectAll('.tick')
    .selectAll('text')
    .attr('font-size', `${width/100}px`)
  
  legendContainer
    .transition('show-legend-container')
    .duration(1000)
    .style('opacity', 1)
}
)})
    },
    {
      name: "addJourneyInfoContainer",
      inputs: ["d3","chart","width","height"],
      value: (function(d3,chart,width,height){return(
() => {
  
  let svg = d3.select(chart)
  
  // The right 1/3 showing relevant information
  let journeyInfoContainer = svg.append('foreignObject')
    .attr('x', width*(2/3))
    .attr('y', 10)
    .attr('width', width*(1/3))
    .attr('height', height*0.85+10)
    .append("xhtml:div")
    .attr('id', 'journey-info-container')
    .style('background-color', '#fff')
    .style('box-shadow', '0 1px 4px 0 rgba(0, 0, 0, 0.37)')
    .style('border-radius', '5px')
    .style('margin-left', `10px`)
    .style('width', `${width*(1/3)-20}px`)
    .style('height', `${height*0.85}px`)
    .style('overflow', 'hidden')
    .style('opacity', 0);
  
  journeyInfoContainer.append("xhtml:img")
    .attr('id', 'journey-info-img')
    .style('width', '100%')
  
  let journeyInfoTextContainer =
      journeyInfoContainer.append("xhtml:div")
        .attr('id', 'journey-info-text-container')
        .style('padding', `${width/80}px`)
  
  journeyInfoTextContainer.append("xhtml:h2")
    .attr('id', 'journey-info-header')
    .style("font-size", `${width/50}px`)
    .style('margin-top', `${width / 80}px`)
    .style('margin-bottom', `${width / 80}px`)
  
  journeyInfoTextContainer.append("xhtml:p")
    .attr('id', 'journey-info-description')
    .style('margin-top', `${width / 100}px`)
    .style('margin-bottom', `${width / 100}px`)
    .style("font-size", `${width / 81.25}px`)
  
  journeyInfoTextContainer.append("xhtml:a")
    .attr('id', 'journey-info-link')
    .style("font-size", `${width / 81.25}px`)
  
  journeyInfoContainer
    .transition('show-journey-info-container')
    .duration(1000)
    .style('opacity', 1)
}
)})
    },
    {
      name: "addYear",
      inputs: ["d3","chart","height","width"],
      value: (function(d3,chart,height,width){return(
() => {
  
  let svg = d3.select(chart)
  
  // Display the current year
  let yearText = svg.append('text')
    .attr("class", "yearText")
    .attr("x", 5)
    .attr("y", height-10)
    .attr('font-size', `${width/15}px`)
    .style("text-anchor", "start") //end
    .text(1961)
    // .call(halo, 10);
}
)})
    },
    {
      name: "moveToLeftTwoThirds",
      inputs: ["projection","width","d3","updateOnProjectionChange"],
      value: (function(projection,width,d3,updateOnProjectionChange){return(
async () => {
  
  // Move projection to the left 2/3 of the svg
  const [currentTranslationX, currentTranslationY] = projection.translate()
  const targetTranslationX = width/3
  const targetTranslationY = currentTranslationY
  let translationXInterpolator =  d3.interpolateNumber(currentTranslationX, targetTranslationX)
  
  // Wait until completing move to new location
  await d3.transition("moveToLeftTwoThirds")
    .duration(3000)
    .ease(d3.easeQuad)
    .tween("render", () => t => {
      projection.translate([translationXInterpolator(t), targetTranslationY]);
      updateOnProjectionChange();
    })
    .end();
}
)})
    },
    {
      name: "visitCountry",
      inputs: ["d3","chart","journey","countryIndex","countries","projection","tilt","Versor","width","quadraticInterpolator","updateJourneyInfo","mutable currentYear","updateOnProjectionChange"],
      value: (function(d3,chart,journey,countryIndex,countries,projection,tilt,Versor,width,quadraticInterpolator,updateJourneyInfo,$0,updateOnProjectionChange){return(
async () => {
  
  let svg = d3.select(chart)
  
  const currentEvent  = journey[countryIndex]
  const country = countries.find(d => d.id === currentEvent.numericCode);
  const previousEventEndYear = (countryIndex > 0 && journey[countryIndex-1].endYear) || 1961
  const currentEventTimeSpan = currentEvent.endYear - currentEvent.startYear
  
  // Check the current projection rotation
  const currentRotation = projection.rotate()
  const currentScale = projection.scale()
  const p1 = [currentRotation[0], currentRotation[1]]
  const p2 = country.properties.centroid;
  const r1 = currentRotation
  const r2 = [-p2[0], tilt - p2[1], 0];
  
  // Construct interpolators
  const iv = Versor.interpolateAngles(r1, r2);
  
  // Scaling interpolator: choose between quadratic and linear interpolator
  let projectionScaleInterpolator;
  let zoomOutScale = currentEvent.projectionScaleZoomOut*(width/975)
  let zoomInScale = currentEvent.projectionScaleZoomIn*(width/975)
  projectionScaleInterpolator = quadraticInterpolator(zoomOutScale,zoomInScale)
  
  const yearTransitionInterpolator = d3.interpolateNumber(previousEventEndYear, currentEvent.startYear)
  const yearProgressionInterpolator = d3.interpolateNumber(currentEvent.startYear, currentEvent.endYear)
    
  updateJourneyInfo(currentEvent)
  
  // Show country labels
  svg
    .select("#country-label-container")
    .selectAll("text")
    .transition('show-country-label')
    .duration(1000)
    .style('opacity', 1)
  
  d3.transition("updateYearTransition")
    .duration(500)
    .ease(d3.easeQuad)
    .tween("updateYear", () => t => {
      $0.value = Math.floor(yearTransitionInterpolator(t))
      // updateOnYearChange(year)
    })
  
  // Wait until completing move to new location
  await d3.transition("moveToNextLocation")
    .duration(5000)
    .ease(d3.easeQuad)
    .tween("render", () => t => {
      projection.rotate(iv(t));
      projection.scale(projectionScaleInterpolator(t));
      updateOnProjectionChange();
    })
    .end(); // .end() returns a promise so you can await on it 
    // (wait for it to finish before performing the next transition)
    
  d3.transition("showEventTransition")
    .duration(currentEventTimeSpan*1000)
    .ease(d3.easeQuad)
    .tween("showEvent", () => t => {
      $0.value = Math.floor(yearProgressionInterpolator(t))
      // updateOnYearChange(year)
    })  
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Update visualization ↓`
)})
    },
    {
      name: "updateJourneyInfo",
      inputs: ["d3","chart"],
      value: (function(d3,chart){return(
(currentEvent) => {

  let svg = d3.select(chart);
  
  svg.select('#journey-info-img')
    .attr('src', currentEvent.imgSrc)
    .attr('alt', currentEvent.title)
  
  svg.select('#journey-info-header')
    .text(currentEvent.title)
  
  svg.select('#journey-info-description')
    .text(currentEvent.description)
  
  svg.select('#journey-info-link')
    .attr('href', currentEvent.link)
    .attr('target', '_blank')
    .text('Learn more on Wikipedia →')
}
)})
    },
    {
      name: "updateOnProjectionChange",
      inputs: ["d3","chart","geoGenerator","generateCountryLabelTransformValue","generateCountryLabelFontValue"],
      value: (function(d3,chart,geoGenerator,generateCountryLabelTransformValue,generateCountryLabelFontValue){return(
() => {

  let svg = d3.select(chart);
  
  // Re-render all the paths elements: choropleth, border, sphere
  svg
    .selectAll("g")
    .selectAll("path")
    .attr('d', geoGenerator)
  
  // For country lables, move, toggle visibility, change font size 
  svg
    .select("#country-label-container")
    .selectAll("text")
    .attr('transform', generateCountryLabelTransformValue)
    .style('visibility', d => geoGenerator(d)? 'visible':'hidden')
    .style('font', generateCountryLabelFontValue)
}
)})
    },
    {
      name: "updateOnYearChange",
      inputs: ["d3","chart","life","currentYear","color","lightOrDark"],
      value: (function(d3,chart,life,currentYear,color,lightOrDark)
{
  
  let svg = d3.select(chart);
  
  // Add Chloropleth
  svg
    .select("#chloropleth-container")
    .selectAll('path')
    .transition('chloropleth-fill-transition')
    .duration(200)
    .attr("fill", d =>
      life.has(d.id) && life.get(d.id)[currentYear+'delta'] ? color(+life.get(d.id)[currentYear+'delta']) : "#eee"
    )
  
  // Display the current year
  svg
    .selectAll('.yearText')
    .text(currentYear)
  
  // Change country label text color based on current year choropleth color value
  svg
    .select("#country-label-container")
    .selectAll("text")
    .attr('fill', d => 
      life.has(d.id) && life.get(d.id)[currentYear+'delta'] && lightOrDark(color(+life.get(d.id)[currentYear+'delta'])) === 'dark' ?
          "#fff" : "#000"
    )
  
  // mutable currentYear = year
}
)
    },
    {
      name: "initial currentYear",
      value: (function(){return(
1961
)})
    },
    {
      name: "mutable currentYear",
      inputs: ["Mutable","initial currentYear"],
      value: (M, _) => new M(_)
    },
    {
      name: "currentYear",
      inputs: ["mutable currentYear"],
      value: _ => _.generator
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Manual Pan/Zoom ↓`
)})
    },
    {

    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Tooltip ↓`
)})
    },
    {
      name: "initial mouseOverCountry",
      inputs: ["countries"],
      value: (function(countries){return(
countries[0]
)})
    },
    {
      name: "mutable mouseOverCountry",
      inputs: ["Mutable","initial mouseOverCountry"],
      value: (M, _) => new M(_)
    },
    {
      name: "mouseOverCountry",
      inputs: ["mutable mouseOverCountry"],
      value: _ => _.generator
    },
    {
      name: "updateTooltipText",
      inputs: ["tooltip","mouseOverCountry","currentYear","life"],
      value: (function(tooltip,mouseOverCountry,currentYear,life)
{
  tooltip.text(`${mouseOverCountry.properties.name} (${currentYear})\n${(+life.get(mouseOverCountry.id)[currentYear]).toFixed(1)}`)
}
)
    },
    {
      name: "onMouseMoveArea",
      inputs: ["tooltip","d3"],
      value: (function(tooltip,d3){return(
(d) => {
  console.log('Mouse move')
  tooltip.style("top", (d3.event.pageY+20)+"px").style("left",(d3.event.pageX+10)+"px");
}
)})
    },
    {
      name: "onMouseOutArea",
      inputs: ["tooltip"],
      value: (function(tooltip){return(
(d) => {
  console.log('Mouse out')
  tooltip.text('')
  tooltip.style("visibility", "hidden");
}
)})
    },
    {
      name: "onMouseOverArea",
      inputs: ["mutable mouseOverCountry","tooltip"],
      value: (function($0,tooltip){return(
(d) => {
  console.log('Mouse over')
  $0.value = d

  tooltip.style("visibility", "visible");
}
)})
    },
    {
      name: "tooltip",
      inputs: ["d3"],
      value: (function(d3)
{
  return d3.select("#svg-tooltip").empty() ? 
  d3.select("body").append("div")
  .attr("id", "svg-tooltip")
  .text("")
  : d3.select("#svg-tooltip")
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Visualization Setup ↓`
)})
    },
    {
      name: "geoGenerator",
      inputs: ["d3","projection"],
      value: (function(d3,projection){return(
d3.geoPath().projection(projection)
)})
    },
    {
      name: "projection",
      inputs: ["d3","margin","width","height","sphere"],
      value: (function(d3,margin,width,height,sphere){return(
d3.geoOrthographic()
               .fitExtent([[margin, margin], [width - margin, height - margin]], sphere)
               .translate([width / 2, height / 2])
               .precision(0.1)
)})
    },
    {
      name: "sphere",
      value: (function(){return(
{type: "Sphere"}
)})
    },
    {
      name: "xAxis",
      inputs: ["d3","xScale","width","lifeExpectancyDeltaMax"],
      value: (function(d3,xScale,width,lifeExpectancyDeltaMax){return(
d3.axisBottom(xScale)
          .tickSize(0)
          .tickPadding(width/55)
          .tickValues([-lifeExpectancyDeltaMax, 0, lifeExpectancyDeltaMax])
)})
    },
    {
      name: "xScale",
      inputs: ["d3","color","legendScaleWidth"],
      value: (function(d3,color,legendScaleWidth){return(
d3.scaleLinear()
           .domain(d3.extent(color.domain()))
           .rangeRound([-legendScaleWidth/2, legendScaleWidth/2])
)})
    },
    {
      name: "color",
      inputs: ["d3","lifeExpectancyDeltaMax"],
      value: (function(d3,lifeExpectancyDeltaMax){return(
d3.scaleSequential(d3.interpolateRdYlGn)
          .domain([-lifeExpectancyDeltaMax, lifeExpectancyDeltaMax])
)})
    },
    {
      name: "lifeExpectancyDeltaMax",
      value: (function(){return(
2
)})
    },
    {
      name: "legendScaleWidth",
      value: (function(){return(
180
)})
    },
    {
      name: "tilt",
      value: (function(){return(
0
)})
    },
    {
      name: "margin",
      inputs: ["height"],
      value: (function(height){return(
height/20
)})
    },
    {
      name: "height",
      inputs: ["width"],
      value: (function(width){return(
Math.floor(width * 0.55)
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Life Expectancy Data ↓`
)})
    },
    {
      name: "life",
      inputs: ["d3"],
      value: (async function(d3)
{
   let data = await d3.csv("https://gist.githubusercontent.com/Jianan-Li/a33f236bb36c2dbac518e5971807b25b/raw/7ccd0d24ef50b3152ce848e7c3f9ce21a0d75af6/world-life-expectancy.csv") 
   let codes = await d3.csv("https://gist.githubusercontent.com/Jianan-Li/a33f236bb36c2dbac518e5971807b25b/raw/7ccd0d24ef50b3152ce848e7c3f9ce21a0d75af6/country-codes.csv")
 
  // Calculate the delta of life expectancy between years
  data.map(d => {
    for (let i=2016; i>=1961; i--) { 
      if (d[i-1] === '' || d[i] === '') {
        d[i+'delta'] = ''
      } else {
        d[i+'delta']=d[i]-d[i-1]
      }
    }
    return d
  })
  
  const countryLetterCodeToNumericCode = new Map(codes.map(d => [d["alpha-3"], d["country-code"]]));

  return new Map(
    data
      .filter(d => countryLetterCodeToNumericCode.has(d["Country Code"]))
      .map(d => [countryLetterCodeToNumericCode.get(d["Country Code"]), d])
  );
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Helper Functions and Class ↓`
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<div style="padding-top: 10px;"><h5><a href="https://observablehq.com/@johnburnmurdoch/bar-chart-race#halo" target="_blank">Add White Border Around Text Element in SVG</a> ↓</h5></div>`
)})
    },
    {
      name: "halo",
      value: (function(){return(
function(text, strokeWidth) {
  text.select(function() { return this.parentNode.insertBefore(this.cloneNode(true), this); })
    .style("fill", '#ffffff')
    .style("stroke", '#ffffff')
    .style('stroke-width', strokeWidth)
    .style('stroke-linejoin', 'round')
    .style("opacity", 1)
    .style("fill", '#ffffff')
}
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<div style="padding-top: 10px;"><h5><a href="https://observablehq.com/@d3/world-tour#Versor" target="_blank">Angle Interpolation (for projection rotation)</a> ↓</h5></div>`
)})
    },
    {
      name: "Versor",
      value: (function(){return(
class Versor {
  static fromAngles([l, p, g]) {
    l *= Math.PI / 360;
    p *= Math.PI / 360;
    g *= Math.PI / 360;
    const sl = Math.sin(l), cl = Math.cos(l);
    const sp = Math.sin(p), cp = Math.cos(p);
    const sg = Math.sin(g), cg = Math.cos(g);
    return [
      cl * cp * cg + sl * sp * sg,
      sl * cp * cg - cl * sp * sg,
      cl * sp * cg + sl * cp * sg,
      cl * cp * sg - sl * sp * cg
    ];
  }
  static toAngles([a, b, c, d]) {
    return [
      Math.atan2(2 * (a * b + c * d), 1 - 2 * (b * b + c * c)) * 180 / Math.PI,
      Math.asin(Math.max(-1, Math.min(1, 2 * (a * c - d * b)))) * 180 / Math.PI,
      Math.atan2(2 * (a * d + b * c), 1 - 2 * (c * c + d * d)) * 180 / Math.PI
    ];
  }
  static interpolateAngles(a, b) {
    const i = Versor.interpolate(Versor.fromAngles(a), Versor.fromAngles(b));
    return t => Versor.toAngles(i(t));
  }
  static interpolateLinear([a1, b1, c1, d1], [a2, b2, c2, d2]) {
    a2 -= a1, b2 -= b1, c2 -= c1, d2 -= d1;
    const x = new Array(4);
    return t => {
      const l = Math.hypot(x[0] = a1 + a2 * t, x[1] = b1 + b2 * t, x[2] = c1 + c2 * t, x[3] = d1 + d2 * t);
      x[0] /= l, x[1] /= l, x[2] /= l, x[3] /= l;
      return x;
    };
  }
  static interpolate([a1, b1, c1, d1], [a2, b2, c2, d2]) {
    let dot = a1 * a2 + b1 * b2 + c1 * c2 + d1 * d2;
    if (dot < 0) a2 = -a2, b2 = -b2, c2 = -c2, d2 = -d2, dot = -dot;
    if (dot > 0.9995) return Versor.interpolateLinear([a1, b1, c1, d1], [a2, b2, c2, d2]); 
    const theta0 = Math.acos(Math.max(-1, Math.min(1, dot)));
    const x = new Array(4);
    const l = Math.hypot(a2 -= a1 * dot, b2 -= b1 * dot, c2 -= c1 * dot, d2 -= d1 * dot);
    a2 /= l, b2 /= l, c2 /= l, d2 /= l;
    return t => {
      const theta = theta0 * t;
      const s = Math.sin(theta);
      const c = Math.cos(theta);
      x[0] = a1 * c + a2 * s;
      x[1] = b1 * c + b2 * s;
      x[2] = c1 * c + c2 * s;
      x[3] = d1 * c + d2 * s;
      return x;
    };
  }
}
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<div style="padding-top: 10px;"><h5>Quadratic Interpolation (for projection scaling) ↓</h5></div>`
)})
    },
    {
      name: "quadraticInterpolator",
      inputs: ["projection"],
      value: (function(projection){return(
(projectionScaleZoomOut, projectionScaleZoomIn) => {
  let c = projection.scale()
  
  if (c > projectionScaleZoomOut) {
    let X = projectionScaleZoomIn - c //(a+b)
    let Y = 4*( c - projectionScaleZoomOut ) //(b^2/a)

    let b = - Math.sqrt(X*Y+(Y**2)/4) - Y/2
    let a = X - b

    return (t) => a*t**2 + b*t + c
  } else {
    let a = projectionScaleZoomIn - c // a
    return (t) => a*t**2 + c
  }
}
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<div style="padding-top: 10px;"><h5>Generate transform value for country labels ↓</h5></div>`
)})
    },
    {
      name: "generateCountryLabelTransformValue",
      inputs: ["geoGenerator","projection"],
      value: (function(geoGenerator,projection){return(
d => {
  if (geoGenerator(d) === null) return 'translate(0,0)'
  return `translate(${projection(d.properties.centroid)})`
}
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<div style="padding-top: 10px;"><h5>Generate font value for country labels ↓</h5></div>`
)})
    },
    {
      name: "generateCountryLabelFontValue",
      inputs: ["projection"],
      value: (function(projection){return(
d => {
  let labelLength = 6/d.properties.name.length
  let countryLongitudeSpan = d.properties.longitudeSpan/5
  let projectionScale = projection.scale()/50
  let a = Math.min(labelLength * countryLongitudeSpan, 50)
  let b = Math.min(a * projectionScale, 12)
  
  return `${b}px sans-serif`
}
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<div style="padding-top: 10px;"><h5>Calculate country longitude span ↓</h5></div>`
)})
    },
    {
      name: "getCountryLongitudeSpan",
      inputs: ["topojson"],
      value: (function(topojson){return(
country => {
  let [x0, y0, x1, y1] = topojson.bbox(topojson.topology(country))
  return x1 - x0
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### <a href="https://github.com/topojson/topojson#topojson" target="_blank">TopoJSON</a> Library Exploration ↓`
)})
    },
    {
      inputs: ["topojson","countries"],
      value: (function(topojson,countries){return(
topojson.bbox(topojson.topology(countries[0]))
)})
    },
    {
      inputs: ["topojson","world"],
      value: (function(topojson,world){return(
topojson.bbox(world)
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Generate Geo Features ↓`
)})
    },
    {
      name: "countries",
      inputs: ["topojson","world","countryNumericCodeToName","d3","getCountryLongitudeSpan"],
      value: (function(topojson,world,countryNumericCodeToName,d3,getCountryLongitudeSpan)
{
  let result = topojson.feature(world, world.objects.countries).features
  result.map(d => {
    d.properties.name = countryNumericCodeToName.get(d.id)
    d.properties.centroid = d3.geoCentroid(d)
    d.properties.longitudeSpan = getCountryLongitudeSpan(d)
  })
  return result
}
)
    },
    {
      name: "interiorBorders",
      inputs: ["topojson","world"],
      value: (function(topojson,world){return(
topojson.mesh(world, world.objects.countries, (a, b) => a !== b)
)})
    },
    {
      name: "allBorders",
      inputs: ["topojson","world"],
      value: (function(topojson,world){return(
topojson.mesh(world, world.objects.countries)
)})
    },
    {
      name: "land",
      inputs: ["topojson","world"],
      value: (function(topojson,world){return(
topojson.feature(world, world.objects.land)
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Fetch Geo Data ↓`
)})
    },
    {
      name: "countryNumericCodeToName",
      inputs: ["d3"],
      value: (async function(d3){return(
new Map(
  await d3.tsv("https://unpkg.com/world-atlas@1/world/110m.tsv", ({iso_n3, name_long}) => [iso_n3, name_long])
)
)})
    },
    {
      name: "world",
      value: (function(){return(
fetch("https://unpkg.com/world-atlas@1/world/110m.json")
        .then(response => response.json())
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Import ↓`
)})
    },
    {
      name: "$",
      inputs: ["require"],
      value: (function(require){return(
require("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js")
)})
    },
    {
      name: "topojson",
      inputs: ["require"],
      value: (function(require){return(
require("topojson@3")
)})
    },
    {
      name: "d3GeoZoom",
      inputs: ["require"],
      value: (function(require){return(
require('d3-geo-zoom')
)})
    },
    {
      name: "d3",
      inputs: ["require"],
      value: (function(require){return(
require("d3@5")
)})
    },
    {
      from: "@jianan-li/utility",
      name: "lightOrDark",
      remote: "lightOrDark"
    },
    {
      from: "@jashkenas/inputs",
      name: "slider",
      remote: "slider"
    },
    {
      from: "@jashkenas/inputs",
      name: "button",
      remote: "button"
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Style ↓`
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html`<style>
#nextButton {
  transition: background-color 0.2s;
  font-size: 1rem;
  width: 8rem;
  height: 2.2rem;
  text-decoration: none;
  border-radius: 0.5rem;
  outline: none;
  cursor: pointer;
  border: none;
  background-color: #eee;
  margin-top: 1.5rem;
}
#nextButton:hover {
  background-color: #ddd;
}
#nextButton:active {
  background-color: #ccc;
}

p, a, text {
  font-family: sans-serif;
}
text.yearText {
  font-weight: 700;
  fill: #777;
}
#svg-tooltip {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple   Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  background: rgba(69,77,93,.9);
  border-radius: .1rem;
  color: #fff;
  display: block;
  font-size: 11px;
  max-width: 320px;
  padding: .2rem .4rem;
  position: absolute;
  text-overflow: ellipsis;
  white-space: pre;
  z-index: 300;
  visibility: hidden;
}
.flex-container {
  margin: 0;
  display: flex;
  justify-content: center;
  height: 4rem;
}
img {
  border-radius: initial;
}
</style>`
)})
    }
  ]
};

const m1 = {
  id: "@jianan-li/utility",
  variables: [
    {
      name: "lightOrDark",
      value: (function(){return(
(color) => {

    // Variables for red, green, blue values
    var r, g, b, hsp;
    
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

        // If HEX --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        
        r = color[1];
        g = color[2];
        b = color[3];
    } 
    else {
        
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace( 
        color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    // default: hsp>127.5
    if (hsp>160) {

        return 'light';
    } 
    else {

        return 'dark';
    }
}
)})
    }
  ]
};

const m2 = {
  id: "@jashkenas/inputs",
  variables: [
    {
      name: "slider",
      inputs: ["input"],
      value: (function(input){return(
function slider(config = {}) {
  let {value, min = 0, max = 1, step = "any", precision = 2, title, description, getValue, format, display, submit} = config;
  if (typeof config == "number") value = config;
  if (value == null) value = (max + min) / 2;
  precision = Math.pow(10, precision);
  if (!getValue) getValue = input => Math.round(input.valueAsNumber * precision) / precision;
  return input({
    type: "range", title, description, submit, format, display,
    attributes: {min, max, step, value},
    getValue
  });
}
)})
    },
    {
      name: "button",
      inputs: ["input"],
      value: (function(input){return(
function button(config = {}) {
  let {value, title, description, disabled} = config;
  if (typeof config == "string") value = config;
  if (!value) value = "Ok";
  const form = input({
    type: "button", title, description,
    attributes: {disabled, value}
  });
  form.output.remove();
  return form;
}
)})
    },
    {
      name: "input",
      inputs: ["html","d3format"],
      value: (function(html,d3format){return(
function input(config) {
  let {
    form,
    type = "text",
    attributes = {},
    action,
    getValue,
    title,
    description,
    format,
    display,
    submit,
    options
  } = config;
  const wrapper = html`<div></div>`;
  if (!form)
    form = html`<form>
	<input name=input type=${type} />
  </form>`;
  Object.keys(attributes).forEach(key => {
    const val = attributes[key];
    if (val != null) form.input.setAttribute(key, val);
  });
  if (submit)
    form.append(
      html`<input name=submit type=submit style="margin: 0 0.75em" value="${
        typeof submit == "string" ? submit : "Submit"
      }" />`
    );
  form.append(
    html`<output name=output style="font: 14px Menlo, Consolas, monospace; margin-left: 0.5em;"></output>`
  );
  if (title)
    form.prepend(
      html`<div style="font: 700 0.9rem sans-serif;">${title}</div>`
    );
  if (description)
    form.append(
      html`<div style="font-size: 0.85rem; font-style: italic;">${description}</div>`
    );
  if (format) format = typeof format === "function" ? format : d3format.format(format);
  if (action) {
    action(form);
  } else {
    const verb = submit
      ? "onsubmit"
      : type == "button"
      ? "onclick"
      : type == "checkbox" || type == "radio"
      ? "onchange"
      : "oninput";
    form[verb] = e => {
      e && e.preventDefault();
      const value = getValue ? getValue(form.input) : form.input.value;
      if (form.output) {
        const out = display ? display(value) : format ? format(value) : value;
        if (out instanceof window.Element) {
          while (form.output.hasChildNodes()) {
            form.output.removeChild(form.output.lastChild);
          }
          form.output.append(out);
        } else {
          form.output.value = out;
        }
      }
      form.value = value;
      if (verb !== "oninput")
        form.dispatchEvent(new CustomEvent("input", { bubbles: true }));
    };
    if (verb !== "oninput")
      wrapper.oninput = e => e && e.stopPropagation() && e.preventDefault();
    if (verb !== "onsubmit") form.onsubmit = e => e && e.preventDefault();
    form[verb]();
  }
  while (form.childNodes.length) {
    wrapper.appendChild(form.childNodes[0]);
  }
  form.append(wrapper);
  return form;
}
)})
    },
    {
      name: "d3format",
      inputs: ["require"],
      value: (function(require){return(
require("d3-format@1")
)})
    }
  ]
};

const notebook = {
  id: "4b5cd2654f690e9c@749",
  modules: [m0,m1,m2]
};

export default notebook;
